import { render, staticRenderFns } from "./mobNavigationBar.vue?vue&type=template&id=20f39c6f"
import script from "./mobNavigationBar.vue?vue&type=script&lang=ts"
export * from "./mobNavigationBar.vue?vue&type=script&lang=ts"
import style0 from "./mobNavigationBar.vue?vue&type=style&index=0&id=20f39c6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports